import React, { Fragment } from 'react';
import { Card, Col, Form, Icon, InputNumber, Row, Tooltip } from 'antd';
import { formatCurrency, parserNumber } from '../../../../utils';

export default (props) => {

	const { getFieldDecorator } = props.form;

	const renderTitle = (title, tooltipContent) => {
		return <Fragment>
			<span>{title} <Tooltip title={tooltipContent}><Icon type="info-circle" /></Tooltip></span>
		</Fragment>;
	};

	return (
		<Fragment>
			<Card title="Giá sản phẩm">
				<Row gutter={12}>
					<Col sm={12}>
						<Form.Item
							label={renderTitle('Giá bán lẻ', 'Giá bán cho các khách hàng mua lẻ')}>
							{getFieldDecorator('retailPrice', {
								initialValue: 0
							})(
								<InputNumber style={{ width: '100%' }} formatter={formatCurrency}
														 parser={parserNumber} min={0} />
							)}

						</Form.Item>
					</Col>
					<Col sm={12}>
						<Form.Item
							label={renderTitle('Giá bán buôn', 'Giá bán cho các khách hàng mua với số lượng lớn')}>
							{getFieldDecorator('wholesalePrice', {
								initialValue: 0
							})(
								<InputNumber style={{ width: '100%' }} formatter={formatCurrency}
														 parser={parserNumber} min={0} />
							)}
						</Form.Item>
					</Col>
					<Col sm={12}>
						<Form.Item
							label={renderTitle('Giá nhập', <p>Giá <b>tự động gợi ý </b> khi bạn <b>tạo đơn nhập hàng</b> từ nhà cung
								cấp. Bạn có thể thay đổi tùy theo giá nhập hàng thực tế</p>)}>
							{getFieldDecorator('importPrice', {
								initialValue: 0
							})(
								<InputNumber style={{ width: '100%' }} min={0} formatter={formatCurrency}
														 parser={parserNumber} />
							)}            </Form.Item>
					</Col>
				</Row>
			</Card>
		</Fragment>
	);
};
